import { render, staticRenderFns } from "./TheHeaderEmpty.vue?vue&type=template&id=7aa219ad&"
import script from "./TheHeaderEmpty.vue?vue&type=script&lang=js&"
export * from "./TheHeaderEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports